import { createAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { Row } from '../grid/experimental.grid';

export interface FocusSelectorSelectClosedForPerformerRow {
    rowId: Row['id'];
}

export const focusSelectorSelectClosedForPerformerRow = createAction<
    ActionType,
    FocusSelectorSelectClosedForPerformerRow
>(ActionType.COACHING_FOCUS_SELECTOR__SELECT_CLOSED_FOR_PERFORMER_ROW);
